(function() {
  'use strict';

  /**
   * Newsletter service - Gère les abonnements à la newsletter via Sender.net
   */
  angular
    .module('observatoireApp')
    .service('NewsletterService', NewsletterService);

  NewsletterService.$inject = ['$http', '$q'];

  function NewsletterService($http, $q) {
    var service = this;
    
    // Configuration de l'API Sender.net
    var apiToken = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiN2RkZTljMjE3MjRhZDdhYmIyMzFmNjIxMmViZDI2NzYxMTUyNzkzMDE5MDk1YzU4YTI4MGNhYzZlNWJmMmE2ZjkzZWEwNGNiNWY3ZjE0ZGQiLCJpYXQiOiIxNzA5NzY3MjA0LjY3NzYwNSIsIm5iZiI6IjE3MDk3NjcyMDQuNjc3NjEwIiwiZXhwIjoiNDg2MzM2NzIwNC42NzUzMzUiLCJzdWIiOiIyMzc4ODQiLCJzY29wZXMiOlsiYXBpX2Z1bGwiXX0.JRdMYQZqV7cc-NAjaKgIuGCvxMmuS8Uu0CpG7va9gqjdpqYY_owRyWy7bBZVssRQDbjcHGG64sV7rc_zujZOSI9XihBPgHdj4Q1JcTvi-VPuY0gCnkPFipsl2B6mZZNQjMMzHl3fIn5tnAjFGS6qtPmnr2k6ixRb-STOO7WgGjf_Z_BrnFpFV3eXnXsnHvHJrGLK9_lQlf_fP4YwZz4ptNaVHPLKvR9Ihs4xmYVblT9f5j9hEbV9PH7mN6UH-Dq55Gq0TxKysbNDhTXB5iU09tJfXOVOxJ5TpJhzlrVIMAXLJQ8pYp2SAH5QL7QkLikXty0Fiah5ZAxpMiXLw9vc-g';
    var apiUrl = 'https://api.sender.net/v2';
    
    service.addSubscriber = addSubscriber;
    
    /**
     * Ajoute un abonné à la liste d'envoi Sender.net
     * @param {string} email - L'adresse email à ajouter
     * @return {Promise} - La promesse résolue avec la réponse de l'API ou rejetée avec l'erreur
     */
    function addSubscriber(email) {
      var deferred = $q.defer();
      
      // Configuration de la requête
      var config = {
        headers: {
          'Authorization': 'Bearer ' + apiToken,
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      };
      
      // Données à envoyer
      var data = {
        email: email,
        firstname: "",
				lastname: "",
				groups: ["bqA753"],
				phone: "",
				trigger_automation: false
      };
      
      // Appel à l'API Sender.net pour ajouter l'abonné
      $http.post(apiUrl + '/subscribers', data, config)
        .then(function(response) {
          deferred.resolve(response.data);
        })
        .catch(function(error) {
          deferred.reject(error);
        });
      
      return deferred.promise;
    }
  }
})();
